<template>
  <el-row>
    <el-col>
      <el-card v-if="recommend.src" :body-style="{ padding: '10px' }">
        <img @click="reFreshUrl(recommend.number)" v-lazy="recommend.src" alt="该文章已下架" class="image" />
        <div @click="reFreshUrl(recommend.number)" style="padding: 10px;">
          <div class="card-zi" style="cursor: pointer;">{{recommend.title}}</div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      aNumber: "",
    };
  },
  props: {
    recommend: {
      type: Object,
    },
  },
  methods: {
    reFreshUrl(e) {
      if(e != null){
      if (e != this.aNumber) {
        this.aNumber = e;
        this.$router.push({ path: "/index/article", query: { id: e } });
      }
      this.$store.commit("setartrcleNumber", e);
    }else{
        this.$message({
          message: '该文章已下架',
          type: 'warning'
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  width: 320px;
  padding: 0 20px 0px 0;
  box-sizing: border-box;
  img {
    width: 100%;
    height: 170px;
    cursor: pointer;
  }
}
.card-zi{
  height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
/deep/.el-col {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.01), 0 0 3px rgba(0, 0, 0, 0.04);
  margin: 0 0 20px 0;
}
// @media (max-width: 1500px){
//  /deep/.el-row{
//    width: 300px;
//    height: 300px;
//  }
// }
</style>